import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Box, Checkbox } from '@material-ui/core';
import FormControlLabel from '@mui/material/FormControlLabel';
import ChooseSubscription from './ChooseSubscription';
import ConfirmationPage from './ConfirmationPage';
import { onboardNewCustomer, sendEmail, sendEmailToBrent } from '../utils/OpenCampgroundAPIServices';

const useStyles = theme => ({
    root: {
        position: 'relative',
        // top: '-48px',
        paddingTop: '0',
        padding: '3%',
    },
    button: {
        marginTop: theme.spacing(2),
        width: '100px',
        backgroundColor: '#47a0c4',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#0ba8cd',
            color: '#FFFFFF'
        },
    },
    textfield: {
        margin: theme.spacing(1),
        width: '250px',
        backgroundColor: '#ffffff'
    },
    emailIdField: {
        margin: theme.spacing(1),
        width: '520px'
    },
    website: {
        margin: theme.spacing(1),
        width: '520px',
        backgroundColor: '#ffffff'
    },
    completebutton: {
        align: 'right',
        marginTop: theme.spacing(2),
        marginLeft: '837px',
        width: '120px',
        backgroundColor: '#0ca319',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#3cac3c',
            color: '#FFFFFF'
        },
    }
});

class Review extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chooseSubscription: false,
            review: true,
            complete: false,
            termsAndConditions: false,
            status: false
        }
    }

    async componentDidMount() {
    }

    handleTandCChange = (event) => {
        this.setState({
            termsAndConditions: false,
            termsAndConditions: event.target.checked,
        })
    };

    saveNewCustomer = async () => {
        let saveCustomerResponse = await onboardNewCustomer(this.props.firstName, this.props.lastName, this.props.emailId, this.props.password, this.props.phoneNumber, this.props.username, 
            this.props.businessName, this.props.businessPhoneNumber, this.props.businessEmailAddress, this.props.address, this.props.city, this.props.stateRegion, this.props.postalCode, 
            this.props.country, this.props.website, this.props.locations, this.props.sites, this.props.businessType, this.props.annualVolume, this.props.subscription, this.props.integratedPayments, 
            this.props.amount, this.props.perMonth, this.props.discountPercentage, this.props.discountedAmount)
        console.log(saveCustomerResponse)
        if (saveCustomerResponse.statusCode === 200) {
            sendEmail(this.props.firstName, this.props.emailId, this.props.subscription)
            sendEmailToBrent(this.props.firstName, this.props.lastName, this.props.emailId, this.props.password, this.props.phoneNumber, this.props.username, 
                this.props.businessName, this.props.businessPhoneNumber, this.props.businessEmailAddress, this.props.address, this.props.city, this.props.stateRegion, this.props.postalCode, 
                this.props.country, this.props.website, this.props.locations, this.props.sites, this.props.businessType, this.props.annualVolume, this.props.subscription, this.props.integratedPayments, 
                this.props.amount, this.props.perMonth, this.props.discountPercentage, this.props.discountedAmount)
            this.setState({
                status: true,
                complete: true,
                review: false,
            })
        } else {
            this.setState({
                status: false,
                complete: true,
                review: false,
            })
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <>
                {this.state.chooseSubscription
                    ? <ChooseSubscription firstname={this.props.firstName} lastName={this.props.lastName} emailId={this.props.emailId} password={this.props.password}
                        phoneNumber={this.props.phoneNumber} username={this.props.username} businessName={this.props.businessName} businessPhoneNumber={this.props.businessPhoneNumber}
                        businessEmailAddress={this.props.businessEmailAddress} address={this.props.address} city={this.props.city} stateRegion={this.props.stateRegion} postalCode={this.props.postalCode}
                        country={this.props.country} website={this.props.website} locations={this.props.locations} sites={this.props.sites} businessType={this.props.businessType}
                        annualVolume={this.props.annualVolume} />
                    : null}

                {this.state.complete
                    ? <ConfirmationPage status={this.state.status}/>
                    : null}

                {this.state.review
                    ? <Grid container className={classes.root}>
                        <Box style={{ height: '50px', display: 'flex', flexDirection: 'row', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem' }} >
                                1. Create Account
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                2. Company Information
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                3. Choose a Subscription
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#47a0c4', fontSize: '1.3rem', marginLeft: '10%' }} >
                                4. Complete
                            </Typography>
                        </Box>

                        <Box style={{ height: '700px', display: 'flex', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Grid>
                                <Grid container style={{ justifyContent: 'center' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                        Review and Complete
                                    </Typography>
                                </Grid>
                                <Grid container >
                                    <Box style={{ height: '130px', display: 'flex', width: '50%', background: '#f3f3f3', marginTop: '3%', justifyContent: 'center' }}>
                                        <Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.6rem', fontWeight: 'bold', marginLeft: '-15%' }} >
                                                    Contact Information
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginTop: '5%' }} >
                                                    {this.props.firstName} {this.props.lastName}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem' }} >
                                                    {this.props.emailId}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem' }} >
                                                    {this.props.username}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem' }} >
                                                    {this.props.phoneNumber}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box style={{ height: '130px', display: 'flex', width: '50%', background: '#f3f3f3', marginTop: '3%' }}>
                                        <Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.6rem', fontWeight: 'bold', marginLeft: '60px' }} >
                                                    Subscription choosen
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginTop: '5%', marginLeft: '90px' }} >
                                                    Billed {this.props.subscription}: <b>{this.props.amount} {this.props.perMonth}</b>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid container >
                                    <Box style={{ height: '360px', display: 'flex', width: '50%', background: '#f3f3f3', marginTop: '3%', justifyContent: 'center' }}>
                                        <Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.6rem', fontWeight: 'bold', marginLeft: '-10%' }} >
                                                    Company Information
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginTop: '5%', marginLeft: '5%' }} >
                                                    {this.props.businessName}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '5%' }} >
                                                    {this.props.address} {this.props.city} {this.props.stateRegion} {this.props.postalCode}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '5%' }} >
                                                    {this.props.country}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '5%' }} >
                                                    {this.props.businessEmailAddress}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '5%' }} >
                                                    {this.props.businessPhoneNumber}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '5%' }} >
                                                    {this.props.website}
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginTop: '10%', marginLeft: '5%' }} >
                                                    Number of campsites managed: <b>{this.props.locations}</b>
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '5%' }} >
                                                    Number of total sites: <b>{this.props.sites}</b>
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '5%' }} >
                                                    Annual Volume: <b>${this.props.annualVolume}</b>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box style={{ height: '100px', display: 'flex', width: '50%', background: '#f3f3f3', marginTop: '3%', justifyContent: 'right' }}>
                                        <Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.6rem', fontWeight: 'bold' }} >
                                                    Integrated Payments for reservations
                                                </Typography>
                                            </Grid>
                                            <Grid container>
                                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginTop: '5%', marginLeft: '20px' }} >
                                                    Accepting credit cards for guest reservation: <b>{this.props.integratedPayments}</b>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Grid item style={{ marginLeft: '-25%' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={this.handleTandCChange}
                                                name="acceptTerms"
                                                color="primary"
                                                id="acceptTerms"
                                            />
                                        }
                                        label="I accept the"
                                    />
                                    <a href="https://opencampground.com/privacy-policy/" target="_blank" style={{ marginLeft: '-9px', marginRight: '3px', textDecoration: 'none' }}>
                                        Terms And Conditions
                                    </a> and our
                                    <a href="https://opencampground.com/gdpr/" target="_blank" style={{ marginLeft: '5px', textDecoration: 'none' }}>
                                        Global Privacy Policy
                                    </a>
                                </Grid>
                                <Grid container>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.setState({ chooseSubscription: true, review: false }) }} >Back </Button>
                                    <Button variant="contained" color="primary" className={classes.completebutton} onClick={this.saveNewCustomer} disabled={!this.state.termsAndConditions}>Complete </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    : null
                }
            </>
        );
    };
};

export default withStyles(useStyles)(Review);